import { z } from "zod";

import {
  inviteeInfoAndAccessControlForTopicSchema,
  topicAccessInviteTokenResponseSchema,
  userInfoAndAccessControlForTopicSchema,
} from "api/schemas/topicShareApiSchema";

export const invitationStateSchema = z.object({
  error: z.boolean(),
  isPending: z.boolean(),
});

export const shareLinkSchema = z.object({
  error: z.boolean(),
  isPending: z.boolean(),
  token: z.string().optional(),
});

export const openLinkStateSchema = z.object({
  data: topicAccessInviteTokenResponseSchema.optional(),
  errorStatus: z.number().optional(),
  isPending: z.boolean(),
});

export const collaboratorSchema = userInfoAndAccessControlForTopicSchema;

export const inviteeSchema = inviteeInfoAndAccessControlForTopicSchema;

export const collaboratorStateSchema = z.object({
  collaborators: z.array(collaboratorSchema),
  error: z.boolean(),
  invitees: z.array(inviteeSchema),
  isPending: z.boolean(),
});

const editorViewerPermission = z.enum(["editor", "viewer"]);
const mapPermissionSchema = z.enum(["editor", "viewer"]);

export const inviteSchema = z.object({
  email: z.string(),
  permission: editorViewerPermission,
});

export const inviteMetaSchema = z.object({
  invitations: z.array(inviteSchema),
  mapId: z.string(),
});

export const mapRemoveInviteMetaSchema = z.object({
  email: z.string(),
  removeMap: z.boolean().optional(),
  topic_id: z.string(),
});

export const changeInvitePermissionMetaSchema = z.object({
  email: z.string(),
  permission: mapPermissionSchema,
  topic_id: z.string(),
});

export const createLinkMetaSchema = z.object({
  permission: mapPermissionSchema,
  topic_id: z.string(),
});

export const acceptInviteMetaSchema = z.object({
  id: z.string(),
  token: z.string(),
});

export const acceptMapInviteFailedPayloadSchema = z.object({
  id: z.string(),
  isDeleted: z.boolean(),
  isExpired: z.boolean(),
  token: z.string(),
});
